import type { FC } from "react";
import { cn } from "../../../utils";
import { Group, type GroupProps } from "../../group";

export const EditorButtonGroup: FC<GroupProps> = ({ className, ...props }) => (
  <Group type="flex" direction="row" {...props} className={cn("gap-0 items-center", className)} />
);
